import React, { useEffect, useState } from 'react';
import { MapPin, X, Globe } from 'lucide-react';
import { detectGeo } from '../lib/geo';
import { useLanguage } from '../contexts/LanguageContext';
import { useCurrency } from '../contexts/CurrencyContext';

export function GeoDetectionBanner() {
  const { lang, setLanguage } = useLanguage();
  const { setCurrency } = useCurrency();
  const [geo, setGeo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const LANG_NAMES = { en: 'English', pl: 'Polski', fr: 'Français', de: 'Deutsch', it: 'Italiano' };

  useEffect(() => {
    const wasDismissed = sessionStorage.getItem('sac_geo_banner_dismissed');
    if (wasDismissed) return;
    detectGeo().then(g => {
      if (g && (g.lang !== lang || g.currency !== 'EUR')) {
        setGeo(g);
      }
    });
  }, [lang]);

  if (!geo || dismissed) return null;

  const handleAccept = () => {
    setLanguage(geo.lang);
    setCurrency(geo.currency);
    sessionStorage.setItem('sac_geo_banner_dismissed', '1');
    setDismissed(true);
  };

  const handleDismiss = () => {
    sessionStorage.setItem('sac_geo_banner_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-sm mx-auto"
      data-testid="geo-banner"
    >
      <div className="bg-[#0A0A0A] border border-gray-700 rounded-xl shadow-2xl p-4 flex items-start gap-3">
        <div className="w-8 h-8 rounded-full bg-red-600/20 flex items-center justify-center flex-shrink-0 mt-0.5">
          <MapPin size={14} className="text-red-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-semibold leading-tight mb-0.5">
            We detected you're in {geo.city || geo.country}
          </p>
          <p className="text-gray-400 text-xs mb-3">
            Switch to <span className="text-white font-medium">{LANG_NAMES[geo.lang]}</span> and <span className="text-white font-medium">{geo.currency}</span>?
          </p>
          <div className="flex gap-2">
            <button
              onClick={handleAccept}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-red-600 hover:bg-red-500 text-white text-xs font-bold rounded-lg transition-colors"
              data-testid="geo-accept-btn"
            >
              <Globe size={11} /> Yes, switch
            </button>
            <button
              onClick={handleDismiss}
              className="px-3 py-1.5 border border-gray-700 text-gray-400 hover:text-white text-xs rounded-lg transition-colors"
              data-testid="geo-dismiss-btn"
            >
              Keep {LANG_NAMES[lang]}
            </button>
          </div>
        </div>
        <button onClick={handleDismiss} className="text-gray-600 hover:text-gray-400 flex-shrink-0">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
